/**
 * @file Проверка формы ответа с данными пользователя.
 *
 * TypeScript описывает тип, но JSON приходит во время выполнения. Эта функция
 * проверяет обязательные поля до передачи данных в состояние приложения.
 */
import type { CustomerInfo } from '../../context/useCustomer'
import { SignInError } from './signInError.ts'

export function parseCustomerInfo(data: unknown): CustomerInfo {
    if (
        typeof data !== 'object' ||
        data === null ||
        !('api_token' in data) ||
        typeof data.api_token !== 'string' ||
        data.api_token.length === 0 ||
        !('boxes' in data) ||
        !Array.isArray(data.boxes) ||
        !data.boxes.every(
            (box: unknown) =>
                typeof box === 'object' &&
                box !== null &&
                'id' in box &&
                typeof box.id === 'string' &&
                box.id.length > 0,
        )
    )
        throw new SignInError('invalidSession')

    if (new Set(data.boxes.map((box) => box.id)).size !== data.boxes.length) {
        throw new SignInError('invalidSession')
    }

    return data as CustomerInfo
}
